var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasHint)?_c('div',{staticClass:"bg-primary-lightest p-4 rounded"},[_c('p',{staticClass:"text-sm",domProps:{"innerHTML":_vm._s(_vm.delivery.address_hint)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }